import React from 'react';

export default function SectionHeader({ title }) {
  return (
    <div className="section-header" style={{ marginBottom: '1.5rem' }}>
      <div className="section-header-inner">
        <h4>{title}</h4>
      </div>
    </div>
  );
}
